// import { asyncComponent } from 'utils'

const dynamicImportExportJsonExcel = () => import(/* webpackChunkName: "exportJsonExcel" */ './ExportJsonExcel');

export default dynamicImportExportJsonExcel;

// export const AsyncExportJsonExcel = asyncComponent(dynamicImportExportJsonExcel)
